import { api } from "./Api";
import { toast } from "react-toastify";
import { IRestGetSpeaker } from "./Interfaces";

export const getSpeakerAll = async (
  offset: number,
  limit: number,
  criteria: any = {}
) => {
  try {
    const params = new URLSearchParams();
    params.append("offset", offset.toString());
    params.append("limit", limit.toString());
    if (criteria.name) params.append("criteria[speaker.name]", criteria.name);
    if (criteria.jobRole)
      params.append("criteria[speaker.jobRole]", criteria.jobRole);
    if (criteria.description)
      params.append("criteria[speaker.description]", criteria.description);
    if (criteria.linkedinUrl)
      params.append("criteria[speaker.linkedinUrl]", criteria.linkedinUrl);
    return toast.promise(
      api.get(`/admin/speaker?${params.toString()}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        responseType: "json",
      }),
      {
        error: "Erro ao buscar palestrantes.",
      }
    );
  } catch (erro) {
    return false;
  }
};

export const getSpeakerById = async (id: string): Promise<IRestGetSpeaker> => {
  try {
    return toast.promise(
      api.get(`/admin/speaker/${id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        responseType: "json",
      }),
      {
        error: "Erro ao buscar palestrante.",
      }
    );
  } catch (erro) {
    throw erro;
  }
};

export const postSpeaker = async (data: {
  name: string;
  jobRole: string;
  description: string;
  linkedinUrl: string;
}) => {
  try {
    return toast.promise(
      api.post(`/admin/speaker`, data, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        responseType: "json",
      }),
      {
        success: "Palestrante cadastrado com sucesso!",
        error: "Erro ao cadastrar palestrante.",
      }
    );
  } catch (erro) {
    return false;
  }
};

export const putSpeaker = async (
  id: string,
  data: {
    name: string;
    jobRole: string;
    description: string;
    linkedinUrl: string;
  }
) => {
  try {
    return toast.promise(
      api.put(`/admin/speaker/${id}`, data, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        responseType: "json",
      }),
      {
        success: "Palestrante atualizado com sucesso!",
        error: "Erro ao atualizar palestrante.",
      }
    );
  } catch (erro) {
    return false;
  }
};

export const uploadSpeakerImage = async (id: string, file: File) => {
  try {
    const formData = new FormData();
    formData.append("upload[pictureFile][file]", file);
    return toast.promise(
      api.post(
        `/admin/upload/Speaker/${id}?uploadAttribute=pictureFile`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "multipart/form-data",
          },
        }
      ),
      {
        success: "Imagem enviada com sucesso!",
        error: "Erro ao enviar imagem do palestrante.",
      }
    );
  } catch (erro) {
    return false;
  }
};
